import React from 'react'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import {
  CALLOUT_BACKGROUND,
  CALLOUT_FOREGROUND,
  OUTLINED_INPUT_BORDER,
  OUTLINED_INPUT_BORDER_RADIUS,
} from 'lib/form-field-styles'

const useStyles = makeStyles(theme => ({
  base: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: CALLOUT_BACKGROUND,
    borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: theme.spacing(2),
    flexShrink: 0,
  },
  icon: {
    color: CALLOUT_FOREGROUND,
    fontSize: 20,
  },
  logo: {
    width: 50,
    minWidth: 50,
  },
  divider: {
    marginRight: theme.spacing(2),
    backgroundColor: OUTLINED_INPUT_BORDER,
  },
  body: {
    color: CALLOUT_FOREGROUND,
    lineHeight: 1.5,
  },
  ctaRow: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .MuiButton-root': {
      minWidth: 0,
      fontWeight: 600,
      textTransform: 'uppercase',
      color: CALLOUT_FOREGROUND,
      letterSpacing: '0.04em',
      paddingLeft: 0,
      paddingRight: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
}))

const DisclaimerWithTwoCta = ({
  logo,
  alt = 'Logo',
  description,
  icon,
  leftCta,
  rightCta,
  show,
}) => {
  const classes = useStyles()

  if (!show) return null

  const leadingVisual = logo ? (
    <img src={logo} alt={alt} className={classes.logo} />
  ) : (
    icon || <InfoOutlinedIcon className={classes.icon} />
  )

  return (
    <Box className={classes.base}>
      <Box className={classes.iconWrapper}>{leadingVisual}</Box>
      <Divider orientation="vertical" flexItem className={classes.divider} />
      <Box display="flex" flexDirection="column" width="100%" minWidth={0}>
        <Typography className={classes.body} variant="body2">
          {description}
        </Typography>
        <Box className={classes.ctaRow}>
          {leftCta}
          {rightCta}
        </Box>
      </Box>
    </Box>
  )
}

export default DisclaimerWithTwoCta
